import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  addAccountTitle: 'Add External Account',
  reviewAccountTitle: 'Review Account Details',
  nameField: 'Name',
  bsbField: 'BSB',
  accountNumberField: 'Account Number',
})
